var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
var messages = defineMessages({
    error: {
        id: 'join.errors.internal',
        defaultMessage: 'Ошибка. Попробуйте позже'
    }
});
var SingleNews = /** @class */ (function (_super) {
    __extends(SingleNews, _super);
    function SingleNews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            news: undefined,
            error: false
        };
        return _this;
    }
    SingleNews.prototype.componentDidMount = function () {
        var _this = this;
        fetch("/get-news?languageId=".concat(this.props.languageId, "&newsId=").concat(this.props.match.params.newsId))
            .then(function (resp) {
            return resp.text();
        })
            .then(function (content) {
            _this.setState({
                news: JSON.parse(content),
                error: undefined
            });
        })
            .catch(function (err) {
            _this.setState({
                error: true
            });
        });
    };
    SingleNews.prototype.render = function () {
        var _a = this.state, news = _a.news, error = _a.error;
        if (error) {
            return (_jsx("div", __assign({ className: 'items', style: { paddingBottom: '15px' } }, { children: _jsx(FormattedMessage, __assign({}, messages.error)) })));
        }
        if (news === undefined) {
            return '';
        }
        return (_jsx("div", __assign({ className: 'items' }, { children: _jsxs("div", __assign({ className: 'item selected' }, { children: [_jsxs("div", __assign({ className: 'head' }, { children: [_jsx("div", __assign({ className: 'title' }, { children: news.title })), _jsx("div", { className: 'expand' })] })), _jsx("div", { className: 'inner', dangerouslySetInnerHTML: { __html: news.content } })] })) })));
    };
    return SingleNews;
}(React.Component));
var mapToState = function (state) { return ({
    languageId: state.application.get('languageId'),
}); };
export default connect(mapToState, null)(SingleNews);



// WEBPACK FOOTER //
// ./src/components/info/news/SingleNews.jsx